import type { ProdutoMarketplace, ImagemProduto, AtributoMarketplace } from '@/models/marketplace/Marketplace'

export interface VerificacaoQualidadeCadastro {
	completo: boolean | undefined
	motivos: string[]
}

export function verificarQualidadeDoCadastro(
	produtoMarketplace: ProdutoMarketplace,
	imagens?: ImagemProduto[],
	atributoCor?: AtributoMarketplace | null,
	atributoTamanho?: AtributoMarketplace | null,
): VerificacaoQualidadeCadastro {
	const motivos: string[] = []

	let temMotivoCritico = false
	
	if (!produtoMarketplace) {
		return { completo: false, motivos: ['Produto não definido'] }
	}

	if (!produtoMarketplace.produto) {
		temMotivoCritico = true
		motivos.push('Produto não selecionado')
	}

	if (!produtoMarketplace.tabelaDePreco) {
		temMotivoCritico
		motivos.push('Tabela de preço não informada')
	}

	if (!produtoMarketplace.categoriaGlobal) {
		temMotivoCritico = true
		motivos.push('Categoria global não informada')
	}

	if (!produtoMarketplace.comprimento || produtoMarketplace.comprimento <= 0) {
		temMotivoCritico = true
		motivos.push('Comprimento não informado')
	}

	if (!produtoMarketplace.peso || produtoMarketplace.peso <= 0) {
		temMotivoCritico = true
		motivos.push('Peso não informado')
	}

	if (!produtoMarketplace.largura || produtoMarketplace.largura <= 0) {
		temMotivoCritico = true
		motivos.push('Largura não informada')
	}

	if (!produtoMarketplace.altura || produtoMarketplace.altura <= 0) {
		temMotivoCritico = true
		motivos.push('Altura não informada')
	}

	if (!produtoMarketplace.unidade) {
		temMotivoCritico = true
		motivos.push('Unidade não informada')
	}

	if (!produtoMarketplace.genero) {
		temMotivoCritico = true
		motivos.push('Gênero não informado')
	}

	if (!produtoMarketplace.descricao
		|| produtoMarketplace.descricao.trim() === ''
		|| produtoMarketplace.descricao.toUpperCase().trim() === 'SEM DESCRIÇÃO'.toUpperCase()) {
		motivos.push('Descrição não informada')
	}

	let imagensProcessadas: ImagemProduto[] = []
	if (imagens && imagens.length > 0) {
		imagensProcessadas = imagens
	} else if (produtoMarketplace.imagens) {
		try {
			imagensProcessadas = JSON.parse(produtoMarketplace.imagens) as ImagemProduto[]
		} catch (e) {
			imagensProcessadas = []
		}
	}

	const imagensFiltradas = imagensProcessadas.filter(imagem => imagem.urlImagem !== null && imagem.urlImagem !== undefined && imagem.urlImagem.trim() !== '')
	if (!imagensFiltradas || imagensFiltradas.length === 0) {
		temMotivoCritico = true
		motivos.push('Nenhuma imagem adicionada')
	}

	const isComVariantes = produtoMarketplace.variantes && produtoMarketplace.variantes.length > 0

	if (isComVariantes) {
		const varianteSemImagem = produtoMarketplace.variantes
			.filter(variante => variante && variante.produto && !imagensFiltradas.map(imagem => imagem.idProduto).includes(variante.produto.id))
		
		if (varianteSemImagem.length > 0) {
			temMotivoCritico = true
			motivos.push(`Variantes sem imagem: ${varianteSemImagem.map(variante => variante.produto.sku).join(', ')}`)
		}

		const variantesSemAtributos = produtoMarketplace.variantes.filter(
			v => !v.atributoCor || !v.atributoTamanho,
		)
		if (variantesSemAtributos.length > 0) {
			temMotivoCritico = true
			motivos.push(`Variantes sem atributos (cor/tamanho): ${variantesSemAtributos.map(v => v.produto.sku).join(', ')}`)
		}
	} else {
		if (atributoCor === undefined) {
			const cor = produtoMarketplace.atributos?.find(a => a.tipoAtributo === 'Cor')
			if (!cor) {
				temMotivoCritico = true
				motivos.push('Atributo cor não informado')
			}
		} else if (!atributoCor) {
			temMotivoCritico = true
			motivos.push('Atributo cor não informado')
		}

		if (atributoTamanho === undefined) {
			const tamanho = produtoMarketplace.atributos?.find(a => a.tipoAtributo === 'Tamanho')
			if (!tamanho) {
				temMotivoCritico = true
				motivos.push('Atributo tamanho não informado')
			}
		} else if (!atributoTamanho) {
			temMotivoCritico = true
			motivos.push('Atributo tamanho não informado')
		}
	}

	if (!produtoMarketplace.canaisVenda || produtoMarketplace.canaisVenda.length === 0) {
		temMotivoCritico = true
		motivos.push('Nenhum canal de venda informado')
	}

	if (!temMotivoCritico && motivos.length > 0) {
		return {
			completo: undefined,
			motivos,
		}
	}


	return {
		completo: motivos.length === 0,
		motivos,
	}
}
